import alignment from './alignment';
import code from './code';
import emphasize from './emphasize';
import headings from './headings';
import link from './links';
import lists from './lists';
import paragraphs from './paragraphs';
import quotes from './quotes';

export default {
  paragraphs,
  headings,
  link,
  lists,

  quotes,
  code,
  emphasize,
  alignment,
};
